<template>
  <span
    class="loading-dots"
    :aria-label="ariaLabel"
    role="img"
    aria-live="polite"
    aria-atomic="true"
  >
    <span aria-hidden="true"></span>
    <span aria-hidden="true"></span>
    <span aria-hidden="true"></span>
  </span>
</template>

<script setup lang="ts">
import { STRINGS } from '@/constants/strings';

interface Props {
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  ariaLabel: STRINGS.ui.loading.loading,
});
</script>
